import http from '@/base/api/public'
import querystring from 'querystring'

let apiUrl = require('@/../config/sysConfig')
// 検索
export const k_0002 = (params) => {
  //params序列化
  let querys = querystring.stringify(params)
  return http.requestGet(apiUrl.apiUrl_AttendExpenseAttendancesExpense + '?' + querys)
}
// 更新
export const k_0002_update = (params) => {
  return http.requestPut(apiUrl.apiUrl_AttendExpenseAttendances, params)
}
//图片取得
export const k_0002_getImage = (params) => {
  return http.requestQuickGetImage('/api/v1/files?filePath=' + encodeURIComponent(params.filePath) + '&resizeCd=' + params.resizeCd)
}
//图片路径等信息取得
export const k_0002_getPhotoInfo = (params) => {
  let querys = querystring.stringify(params)
  return http.requestGet('/api/v1/photoInfo' + '?' + querys)
}
//图片更新
export const k_0002_saveImage = (formData) => {
  let querys = querystring.stringify(formData)
  return http.requestPostFormData(apiUrl.apiUrl_filesUpdate, formData)
}
//保存处理
export const k_0002_Attendances_update = (params) => {
  return http.requestPut(apiUrl.apiUrl_StaffAttendances, params)
}
//m_code
export const conditionApi = (page, div) => {
  return http.requestQuickGet(apiUrl.apiurl_masterData + '/' + page + '/' + div)
}


// WEBPACK FOOTER //
// ./src/module/api/k_0002.js